import { useState } from "react";
import { Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";

export function StartJobButton({ job, onStart }) {
  const [open, setOpen] = useState(false);
  const c = job.client || {};
  return (
    <>
      <Button onClick={() => setOpen(true)} className="w-full rounded-full h-12 bg-[#0f1710] hover:bg-[#1c2a1e]" data-testid="tech-start-button"><Play className="h-4 w-4" /> Inizia intervento</Button>
      <AlertDialog open={open} onOpenChange={setOpen}>
        <AlertDialogContent data-testid="tech-start-confirm-dialog">
          <AlertDialogHeader>
            <AlertDialogTitle>Iniziare adesso l'intervento?</AlertDialogTitle>
            <AlertDialogDescription>
              {c.first_name} {c.last_name}{c.city ? ` · ${c.city}` : ""} · {job.date} {job.start}. Conferma solo se sei sul posto e stai per iniziare il lavoro.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel data-testid="tech-start-cancel">No, torna indietro</AlertDialogCancel>
            <AlertDialogAction onClick={() => { setOpen(false); onStart(); }} data-testid="tech-start-confirm">Sì, inizia</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
}
